import { render, staticRenderFns } from "./BetslipError.vue?vue&type=template&id=3d3a13cb"
import script from "./BetslipError.vue?vue&type=script&lang=js"
export * from "./BetslipError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports